import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import {configure} from "mobx";
import {mobilecheck} from "./utils/Utils";

import ComapFrontend from './ComapFrontend';
import AppStore from './stores/AppStore'

import registerServiceWorker from './registerServiceWorker';

configure({enforceActions: true});

let appStore = new AppStore();

const appConfigPath = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? './appConfig_local.json' : './appConfig.json';

fetch(appConfigPath)
    .then((res) => res.json())
    .then((data) => {
        let appConfig = data;
        appStore.loadConfig(appConfig);

        if (mobilecheck()) {
            appStore.setIsMobile(true);
            appStore.setDrawer({open: false, active: ''});
        }

        ReactDOM.render((
            <Provider appStore={appStore}>

                <ComapFrontend standalone appStore={appStore} renderWithRouter ={true} />
                {/*<TempFrontend standalone appStore={appStore} />*/}
            </Provider>
        ), document.getElementById('root'));


        registerServiceWorker();

    }).catch(error => console.error('Error:', error));



// WEBPACK FOOTER //
// ./src/index.js